<!-- Main Document filters -->
<ng-container *transloco="let t;">
    <div class="documentMainSideBar">
        <div class="ps-2 pt-50 pb-50">
            <div class="d-flex justify-content-between align-items-start">
                <div class="document-custom-filters">
                    <!-- Filters -->
                    <div class="d-flex justify-content-start columngap align-items-center d-flex flex-wrap">
                        <div class="">
                            <app-filter-by-status></app-filter-by-status>
                        </div>
                        <div class="">
                            <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                                <label class="font-small-3 font-weight-500 mb-0 me-25"
                                       for="customSelect">{{ t('Type Filter label (Document and CC filters) - Type') }} </label>
                                <ng-select #SelectDocTypeSR
                                           [ngModel]='(documentFilters$ | async)?.documentTypeId'
                                           [items]="documentTypes"
                                           [readonly]="readonly"
                                           [searchable]="false"
                                           (change)="onDocumentTypeFilterChange($event)"
                                           bindValue="id"
                                           bindLabel="document_type"
                                           [placeholder]="t('Document - listview - filters - All')">
                                    <ng-template ng-header-tmp>
                                        <input class="form-control w-100" type="text"
                                               (input)="SelectDocTypeSR.filter($event.target.value)"/>
                                    </ng-template>

                                    <ng-template ng-label-tmp  ng-option-tmp let-item="item" >
                                        <span class="ng-value-label">
                                            @if (item.id === 0){
                                                {{t('Document - listview - filters - All')}}
                                            }@else{
                                                {{ item.document_type}}
                                            }
                                        </span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
    
    

                    <!-- OLD CATEGORY DROPDOWN - COMMENTED OUT
                        <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                            <label class="font-small-3 font-weight-500 mb-0 me-25"
                                   for="categorySelect">{{ t('Category Filter label (Document and CC filters) - Category') }} </label>
                            <ng-select [ngModel]='(documentFilters$ | async)?.categoryId'
                                       [items]="categories$ | async | documentTypeAllowedCategories"
                                       [readonly]="readonly"
                                       [searchable]="true"
                                       (ngModelChange)="onDocumentCategoryChange($event)"
                                       id="categorySelect"
                                       bindLabel="category_name"
                                       bindValue="id"
                                       [placeholder]="t('Document - listview - filters - All')"
                                       class="cursor-pointer"
                            >
                                <ng-template ng-option-tmp let-item="item">
                                        <div [style.padding-left.px]="(item.level || 0) * 20" class="flex items-center">                                            
                                            <span [class.font-bold]="item.level === 0">
                                                {{ item.category_name }}
                                            </span>
                                        </div>
                                </ng-template>

                                <ng-template ng-label-tmp let-item="item" >
                                    <span class="ng-value-label">
                                        @if (item.id == 0 ){
                                            {{t('Document - listview - filters - All')}}
                                        }@else{
                                            {{ item.category_name}}
                                        }
                                        </span>
                                </ng-template>
                            </ng-select>
                        </div>
                        -->


                        <!-- NEW TREE DROPDOWN -->
                        <div class="">
                            <app-global-category-dropdown
                                [categories]="categories$ | async"
                                [selectedCategoryId]="(documentFilters$ | async)?.categoryId"
                                [label]="t('Category Filter label (Document and CC filters) - Category')"
                                (categorySelected)="onDocumentCategoryChange($event.id)"
                            ></app-global-category-dropdown>
                        </div>
    

    
                        <div class="">
                            <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                                <label class="font-small-3 font-weight-500 mb-0 me-25"
                                       for="customSelect">{{ t('Owner Filter label (Document and CC filters) - Owner') }} </label>
                                <ng-select #SelectDocTypeSR
                                           [items]="ownerFilterDDL$ | async"
                                           [readonly]="readonly"
                                           [searchable]="false"
                                           [compareWith]="compareOwnerFn"
                                           [ngModel]="(documentFilters$ | async).userFilter"
                                           (ngModelChange)="onUserFilterChange($event)"
                                           groupBy="group"
                                           bindLabel="name"
                                           [placeholder]="t('Document - listview - filters - All')">
                                    <ng-template ng-header-tmp>
                                        <input class="form-control w-100" type="text"
                                               [value]="ownerSearch$ | async"
                                               (input)="filterOwner($event?.target?.value)"/>
                                    </ng-template>

                                    <ng-template ng-option-tmp let-item="item" >
                                        <span [ngClass]="{'sub-menu': item?.is_sub && item?.is_sub === 1}">
                                            @if (!item.id ){
                                                {{t('Document - listview - filters - All')}}
                                            }@else if (item.group === OwnerFilterType.me ){
                                                {{t('Document - listview - filters - owner drop down me option - me')}}
                                            } @else {
                                                {{ item.name}}
                                            }
                                        </span>
                                    </ng-template>

                                    <ng-template ng-label-tmp let-item="item">
                                        <span class="ng-value-label">
                                            @if (!item.id ){
                                                {{t('Document - listview - filters - All')}}
                                            }@else if (item.group === OwnerFilterType.me ){
                                                {{t('Document - listview - filters - owner drop down me option - me')}}
                                            } @else {
                                                {{ item.name}}
                                            }
                                        </span>
                                    </ng-template>

                                    <ng-template ng-optgroup-tmp let-item="item">
                                        @if ( item.group!== '' ){
                                            {{ t( ('Document - listview - filters - owner drop down users group name - ' + (item.group.trim() | lowercase))) }}
                                        }
                                    </ng-template>


                                </ng-select>
                            </div>
                        </div>
    
                        <div class="bordered-spacer"></div>
                        <div class="d-flex align-items-center" placement="auto" [autoClose]="true"
                             triggers="hover"
                             [ngbTooltip]="t('Tooltil text for document filters placeholder (Document filters) - Filter on sent uploaded date')">
                            <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                                <label class="font-small-3 font-weight-500 mb-0 me-25"
                                       for="customSelect">{{ t('From date Filter label (Document and CC filters) - From') }} </label>
                                <input id="dateFromFilter" [maxDate]="todayDate"
                                       #fromDate
                                       [ngModel]="(documentFilters$ | async).dateFrom"
                                       (ngModelChange)="onDateFromChange($event)" type="text" mwlFlatpickr
                                       class="form-control firstsecond" [altInput]="true" altFormat="Y-m-d"
                                       dateFormat="Y-m-d"
                                       [placeholder]="t('Document - listview - filters - All')"
                                       [convertModelValue]="true"/>
                            </div>
    
                            <span *ngIf="fromDate?.value" placement="auto" class="d-flex ps-25" container="body"
                                  [autoClose]="true" triggers="hover"
                                  [ngbTooltip]="t('Delete button text (delete button) - delete')"
                                  (click)="onDateFromChange(null)">
                                    <i data-feather="x-circle" [size]="12" class="cursor-pointer text-danger"></i></span>
                        </div>
    
    
                        <div class="align-items-center d-flex align-items-center" placement="auto"
                             [autoClose]="true" triggers="hover"
                             [ngbTooltip]="t('Tooltil text for document filters placeholder (Document filters) - Filter on sent uploaded date')">
                            <div class="form-group mb-0 d-flex justify-content-start align-items-center">
                                <label class="font-small-3 font-weight-500 mb-0 me-25"
                                       for="customSelect">{{ t('From date Filter label (Document and CC filters) - To') }} </label>
                                <input id="dateToFilter" type="text"
                                       [ngModel]="(documentFilters$ | async).dateTo"
                                       (ngModelChange)="onDateTomChange($event)"
                                       [minDate]="(documentFilters$ | async)?.dateFrom" [maxDate]="todayDate" mwlFlatpickr
                                       #toDate
                                       class="form-control firstsecond"
                                       [placeholder]="t('Document - listview - filters - All')"
                                       [altInput]="true"
                                       altFormat="Y-m-d"
                                       dateFormat="Y-m-d" [convertModelValue]="true"/>
                            </div>
                            <span *ngIf="toDate?.value" placement="auto" class="d-flex ps-25" container="body"
                                  [autoClose]="true" triggers="hover"
                                  [ngbTooltip]="t('Delete button text (delete button) - delete')"
                                  (click)="onDateTomChange(null)">
                                    <i data-feather="x-circle" [size]="12" class="text-danger cursor-pointer"></i>
                        </span>
                        </div>
                        <div class="bordered-spacer"></div>
    
                        <div class="form-group mb-0 d-flex justify-content-start d-flex align-items-center">
                            <div ngbDropdown container="body">
                                <button type="button" class="btn btn-sm m-0 p-0 hide-arrow d-flex"
                                        ngbDropdownToggle
                                        data-toggle="dropdown">
                                    <label placement="auto" [autoClose]="true" triggers="hover"
                                           class="font-small-3 cursor-pointer mb-0 me-25 font-weight-500 addvanceFiltertexthover">{{ t('Button name (documents advanced filters) - Advanced filter') }}</label>
                                </button>
                                <div ngbDropdownMenu class="documentAdvanceFilterDropdown">
                                    <app-advanced-filters-list [items]="advancedFiltersList$ | async"
                                                               [loading]="isAdvancedFiltersListLoading$ | async"
                                                               (searchChanged)="advancedFilterSearch($event)"
                                                               (addNewFilter)="addNewFilter($event)"
                                    ></app-advanced-filters-list>
                                </div>
                            </div>
                        </div>
    
    
                        <!-- <div *ngIf="hasAnyFiltersApplied$ | async" class="bordered-spacer"></div> -->
                        <div class="d-flex align-items-center ps-0 cursor-pointer" *ngIf="hasAnyFiltersApplied$ | async">
                            <button class="font-small-3 cursor-pointer btn-sm mb-0 me-25 font-weight-500 addvanceFiltertexthover  btn btn-success" (click)="onSaveFilter()">{{ t('Save filters modal title (save filters modal) - Save filter') }}</button>
                        </div>
                    </div>
                    <!-- Filters -->
                    <!--Advance Filters -->
                    <div class="d-flex add-more-filters p-0">
                        <app-applied-advanced-filter
                                [items]="advancedFiltersList$ | async"
                                [loading]="isAdvancedFiltersListLoading$ | async"
                                [filtersList]="appliedAdvancedFilters$ | async"
                                (addNewFilter)="addNewFilter($event)"
                                (removeFilter)="onRemoveFilter($event)"
                                (search)="advancedFilterSearch($event)"
                        ></app-applied-advanced-filter>
                        
                    </div>
                    <!-- Advance Filters -->
                </div>

                <div class="btn-group perPageRecords me-50">
                    <div ngbDropdown>
                      <button
                        ngbDropdownToggle
                        class="btn btn-flat-secondary"
                        type="button"
                        id="dropdownMenuButton100"
                        rippleEffect
                      >
                        {{perPageRecords}}
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownMenuButton100">
                        <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(20)">20</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(50)">50</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(100)">100</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(500)">500</a>
                        <a ngbDropdownItem href="javascript:void(0)" (click)="setPerPageRecords(1000)">1000</a>
                      </div>
                    </div>
                  </div>

            </div>
        </div>
    </div>

</ng-container>
<!--/ Main Document filters -->
